export const comicCategories = [
  { id: 'korean', name: '韩漫', icon: 'ri-heart-pulse-line', description: '韩国漫画热门连载，高颜值画风，剧情引人入胜' },
  { id: 'japanese', name: '日漫', icon: 'ri-star-smile-line', description: '经典日漫全集，热血、恋爱、奇幻应有尽有' },
  { id: 'chinese', name: '国漫', icon: 'ri-fire-line', description: '国产漫画崛起之作，古风与现代完美融合' },
];

export const comics = [
  {
    id: 1,
    title: '社内恋爱法则',
    author: '金作家',
    category: 'korean',
    tags: ['恋爱', '职场', '甜宠'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20romance%20manhwa%20cover%20featuring%20a%20beautiful%20couple%20in%20modern%20office%20setting%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20light%20pink%20and%20white%20background%2C%20professional%20anime%20art%20quality&width=600&height=800&seq=yaya-comic-01&orientation=portrait',
    description: '入职第一天，她发现直属上司竟是前男友。本想保持距离，却被迫参加公司恋爱模拟项目——两人的关系从办公室蔓延到了虚拟世界。当虚拟的甜蜜撞上现实的尴尬，这场社内恋爱该如何收场？',
    updateInfo: '更新至第89话',
    chapters: 89,
    views: '326万',
    rating: 9.4,
    featured: true,
    isNew: false,
  },
  {
    id: 2,
    title: '重生之豪门千金',
    author: '李漫画家',
    category: 'korean',
    tags: ['重生', '豪门', '逆袭'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20fantasy%20manhwa%20cover%20showing%20an%20elegant%20noble%20woman%20in%20luxurious%20dress%2C%20golden%20palace%20background%2C%20sparkling%20jewelry%2C%20royal%20aesthetic%2C%20warm%20golden%20tones%2C%20delicate%20anime%20art%20style&width=600&height=800&seq=yaya-comic-02&orientation=portrait',
    description: '前世被继母和继妹害死，重生回到十年前。这一次，她不再是那个任人宰割的傻白甜。手握先知剧本，步步为营，她要让所有害过她的人付出代价。',
    updateInfo: '更新至第156话',
    chapters: 156,
    views: '892万',
    rating: 9.7,
    featured: true,
    isNew: false,
  },
  {
    id: 3,
    title: '魔王勇者与圣剑',
    author: '田中一郎',
    category: 'japanese',
    tags: ['奇幻', '冒险', '战斗'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20fantasy%20manga%20cover%20with%20a%20hero%20holding%20a%20glowing%20sword%20facing%20a%20demon%20lord%2C%20epic%20dark%20castle%20background%2C%20dramatic%20lighting%2C%20action%20pose%2C%20vibrant%20colors%2C%20classic%20shonen%20manga%20art%20style&width=600&height=800&seq=yaya-comic-03&orientation=portrait',
    description: '平凡高中生一觉醒来，发现自己穿越到了游戏世界。他成了预言中注定击败魔王的勇者，但魔王似乎...是个可爱的女孩子？当剑与魔法交织，一段啼笑皆非的冒险开始了。',
    updateInfo: '更新至第203话',
    chapters: 203,
    views: '1500万',
    rating: 9.8,
    featured: true,
    isNew: false,
  },
  {
    id: 4,
    title: '青梅不及天降',
    author: '佐藤花子',
    category: 'japanese',
    tags: ['校园', '恋爱', '青春'],
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20school%20romance%20manga%20cover%20with%20two%20girls%20and%20one%20boy%20under%20cherry%20blossom%20trees%2C%20spring%20atmosphere%2C%20soft%20pink%20petals%2C%20school%20uniform%2C%20gentle%20watercolor%20style%2C%20romantic%20mood&width=600&height=800&seq=yaya-comic-04&orientation=portrait',
    description: '从小到大都在一起的青梅竹马，她以为这就是命中注定。直到转校生的出现，打破了一切。三个人之间微妙的情感变化，青春的选择题，答案究竟是什么？',
    updateInfo: '全120话已完结',
    chapters: 120,
    views: '680万',
    rating: 9.2,
    featured: false,
    isNew: false,
  },
  {
    id: 5,
    title: '斗罗大陆外传',
    author: '唐家三少',
    category: 'chinese',
    tags: ['玄幻', '热血', '战斗'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20manhua%20cover%20featuring%20a%20martial%20artist%20with%20glowing%20spirit%20rings%2C%20ancient%20Chinese%20palace%20and%20mountains%20background%2C%20mystical%20energy%20effects%2C%20dynamic%20composition%2C%20ink%20wash%20and%20modern%20blend%20style&width=600&height=800&seq=yaya-comic-05&orientation=portrait',
    description: '唐三成神之后的故事。新的世界，新的敌人，更强的魂环配置。当神界遭遇前所未有的危机，曾经的热血少年能否再次挺身而出，守护他所珍视的一切？',
    updateInfo: '更新至第310话',
    chapters: 310,
    views: '2300万',
    rating: 9.6,
    featured: true,
    isNew: false,
  },
  {
    id: 6,
    title: '我被困在同一天',
    author: '朴编剧',
    category: 'korean',
    tags: ['悬疑', '循环', '惊悚'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20thriller%20manhwa%20cover%20with%20a%20person%20trapped%20in%20time%20loop%20concept%2C%20broken%20clock%20imagery%2C%20dark%20urban%20street%20at%20night%2C%20mysterious%20atmosphere%2C%20cool%20blue%20and%20purple%20tones%2C%20suspenseful%20mood%2C%20psychological%20thriller%20vibe&width=600&height=800&seq=yaya-comic-06&orientation=portrait',
    description: '每天早上醒来，都是同一天——7月15日。她已经在这个循环里困了三年。每当试图逃离，总有人会死。而今天，她发现了一个惊人的秘密：这个城市里，不止她一个人在循环。',
    updateInfo: '更新至第67话',
    chapters: 67,
    views: '450万',
    rating: 9.5,
    featured: false,
    isNew: true,
  },
  {
    id: 7,
    title: '海贼之歌',
    author: '村上大辅',
    category: 'japanese',
    tags: ['冒险', '友情', '热血'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?width=600&height=800&seq=yaya-comic-07&orientation=portrait&query=A%20Japanese%20adventure%20manga%20cover%20with%20pirates%20on%20a%20ship%20sailing%20stormy%20seas%2C%20dramatic%20sky%2C%20treasure%20map%20elements%2C%20crew%20of%20colorful%20characters%2C%20epic%20scale%2C%00vibrant%20and%20bold%20colors%2C%20classic%20adventure%20manga%20style',
    description: '在一个被大海覆盖的世界，少年带着父亲留下的神秘地图，踏上了寻找传说之岛的旅程。一路上，他结识了各怀绝技的伙伴，也发现了这个世界隐藏的真相。',
    updateInfo: '更新至第567话',
    chapters: 567,
    views: '3500万',
    rating: 9.9,
    featured: true,
    isNew: false,
  },
  {
    id: 8,
    title: '狐妖小红娘·续',
    author: '小新',
    category: 'chinese',
    tags: ['仙侠', '爱情', '古风'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20romance%20manhua%20cover%20with%20a%20beautiful%20fox%20spirit%20woman%20and%20a%20scholar%20under%20moonlight%2C%20ancient%20Chinese%20architecture%2C%20peach%20blossoms%2C%20ethereal%20atmosphere%2C%20soft%20ink%20wash%20painting%20style%2C%20dreamy%20pink%20and%20gold%20tones&width=600&height=800&seq=yaya-comic-08&orientation=portrait',
    description: '涂山红红与东方月初的转世再度相遇。千年的等待，换来的却是一场更大的阴谋。妖界与人界的平衡即将被打破，他们的爱情能否跨越种族的鸿沟？',
    updateInfo: '更新至第188话',
    chapters: 188,
    views: '1200万',
    rating: 9.5,
    featured: false,
    isNew: false,
  },
  {
    id: 9,
    title: '明星养成系统',
    author: '金编剧',
    category: 'korean',
    tags: ['娱乐圈', '系统', '逆袭'],
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20entertainment%20manhwa%20cover%20showing%20a%20trainee%20becoming%20a%20star%20on%20stage%2C%20spotlight%20effects%2C%20glamorous%20performance%20scene%2C%20microphone%20and%20stage%20lights%2C%20sparkling%20atmosphere%2C%20modern%20K-pop%20aesthetic%2C%20vibrant%20neon%20accents&width=600&height=800&seq=yaya-comic-09&orientation=portrait',
    description: '练习生三年，出道失败。绝望之际，手机上突然出现了一个「明星养成系统」APP。完成任务就能获得技能点：唱功+10，舞蹈+10，颜值+10。这一次，她要登上顶峰的舞台。',
    updateInfo: '全98话已完结',
    chapters: 98,
    views: '560万',
    rating: 9.1,
    featured: false,
    isNew: false,
  },
  {
    id: 10,
    title: '废柴逆天',
    author: '天蚕土豆',
    category: 'chinese',
    tags: ['玄幻', '热血', '升级'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20cultivation%20manhua%20cover%20with%20a%20young%20warrior%20breaking%20through%20boundaries%2C%20energy%20explosion%20effects%2C%20floating%20mountains%20in%20background%2C%20ancient%20Chinese%20mythological%20elements%2C%20dramatic%20lighting%2C%20bold%20red%20and%20gold%20color%20scheme&width=600&height=800&seq=yaya-comic-10&orientation=portrait',
    description: '天生废脉，无法修炼。被家族驱逐，被世人嘲笑。直到他在后山捡到了一块神秘的玉佩——里面住着一位上古大能的残魂。从此，废柴的逆袭之路，正式开启。',
    updateInfo: '更新至第445话',
    chapters: 445,
    views: '1800万',
    rating: 9.3,
    featured: false,
    isNew: false,
  },
  {
    id: 11,
    title: '猫咪咖啡厅',
    author: '小林优子',
    category: 'japanese',
    tags: ['治愈', '日常', '美食'],
    status: '已完结',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20slice%20of%20life%20manga%20cover%20with%20cute%20cats%20in%20a%20cozy%20cafe%20setting%2C%20warm%20sunlight%20through%20windows%2C%20coffee%20and%20pastries%2C%20relaxing%20atmosphere%2C%20soft%20watercolor%20style%2C%20gentle%20cream%20and%20brown%20tones&width=600&height=800&seq=yaya-comic-11&orientation=portrait',
    description: '辞去东京的工作后，她在老家的街角开了一家猫咪咖啡厅。每天和五只性格各异的猫咪一起迎接客人，听他们讲述各自的故事。温暖、治愈，这就是她想要的生活。',
    updateInfo: '全68话已完结',
    chapters: 68,
    views: '280万',
    rating: 9.0,
    featured: false,
    isNew: true,
  },
  {
    id: 12,
    title: '大奉打更人',
    author: '卖报小郎君',
    category: 'chinese',
    tags: ['武侠', '探案', '搞笑'],
    status: '连载中',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20detective%20manhua%20cover%20with%20a%20constable%20in%20ancient%20Chinese%20uniform%2C%20night%20watch%20scene%2C%20lantern%20lights%2C%20mysterious%20ancient%20city%20alley%2C%20moonlight%2C%20atmospheric%20noir%20with%20Chinese%20aesthetics&width=600&height=800&seq=yaya-comic-12&orientation=portrait',
    description: '现代法医穿越到大奉王朝，成了一名小小打更人。本想混吃等死，奈何案件不断找上门。现代法医学+古代武侠，破案、修炼两不误，看他在这个世界搅动风云。',
    updateInfo: '更新至第267话',
    chapters: 267,
    views: '980万',
    rating: 9.6,
    featured: false,
    isNew: false,
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const newComics = comics.filter(c => c.isNew);
export const koreanComics = comics.filter(c => c.category === 'korean');
export const japaneseComics = comics.filter(c => c.category === 'japanese');
export const chineseComics = comics.filter(c => c.category === 'chinese');

export const aboutInfo = {
  brandName: '丫丫漫画',
  founded: '2020年',
  slogan: '好看的漫画，一网打尽',
  intro: '丫丫漫画成立于2020年，是国内领先的免费在线漫画阅读平台。我们致力于为广大漫画爱好者提供丰富、优质的漫画内容，涵盖韩漫、日漫、国漫等热门分类，支持全集下拉式阅读，让阅读体验更加流畅舒适。',
  features: [
    { title: '海量资源', description: '收录数万部热门漫画，涵盖韩漫、日漫、国漫等多种类型，每日持续更新，追更不等待。' },
    { title: '免费阅读', description: '所有漫画完全免费，无隐藏收费，不设阅读限制，让每位漫画爱好者都能畅享阅读乐趣。' },
    { title: '下拉式阅读', description: '采用流畅的下拉式阅读模式，无需翻页，一气呵成。支持自适应屏幕，手机阅读同样舒适。' },
    { title: '及时更新', description: '与各大漫画平台同步更新，第一时间推送最新章节，追更收藏随时看，精彩不错过。' },
  ],
  reputation: [
    { metric: '500万+', label: '月活跃用户' },
    { metric: '3万+', label: '收录漫画作品' },
    { metric: '99.7%', label: '用户好评率' },
    { metric: '24h', label: '更新时效' },
  ],
  contact: {
    email: 'contact@yaya-comic.com',
    wechat: 'yaya_comic_official',
    weibo: '@丫丫漫画官方',
    address: '北京市朝阳区望京SOHO T3-B座 1208室',
    phone: '400-888-6666',
    workingHours: '周一至周日 9:00 - 22:00',
  },
  faqs: [
    { q: '丫丫漫画是否完全免费？', a: '是的，丫丫漫画平台上的所有漫画内容均完全免费，无需任何付费即可畅享阅读。我们通过广告收入来维持平台运营，不会向用户收取任何费用。' },
    { q: '如何收藏喜欢的漫画？', a: '在漫画详情页点击「收藏」按钮即可将该漫画添加到您的收藏列表中。收藏后，当漫画更新时您将第一时间收到通知。' },
    { q: '下拉式阅读是什么意思？', a: '下拉式阅读是一种连续滚动的阅读模式，您只需向下滑动屏幕即可持续阅读，无需点击翻页按钮。这种模式让阅读更加流畅自然，特别适合手机端阅读。' },
    { q: '漫画更新频率是怎样的？', a: '不同漫画的更新频率不同，热门连载漫画通常每周更新1-3话。您可以在漫画详情页查看具体的更新时间表。' },
    { q: '支持哪些设备阅读？', a: '丫丫漫画支持所有主流设备，包括手机、平板和电脑。我们采用响应式设计，会自动适配不同屏幕尺寸，为您提供最佳的阅读体验。' },
    { q: '如何反馈问题或建议？', a: '您可以通过「关于我们」页面上的联系方式与我们取得联系，包括邮箱、微信公众号和官方微博。我们非常重视每一位用户的反馈。' },
  ],
};